(function($) {

  var script = {};

  /* Define Functions */

  script.addToPreferiti = function() {

    var currentLocation = window.location;
    var uri = currentLocation.origin;

    $('a[data-prefer]').click(function(event) {
      event.preventDefault();
      var auto = $(this).data('prefer');
      console.log('Aggiungo ai preferiti ' + auto);
      var endpoint = uri + "/wp-json/petrolini/v1/preferenze/add";
      console.log(endpoint);

      $.post(
        endpoint, {
          idauto: auto
        },
        function(data) {
          console.log(data);
          $('.notificaAgg-' + auto).animate({
            opacity: 1
          }, 2000);
          $('.notificaAgg-' + auto).animate({
            opacity: 0
          }, 2000);
          location.reload();
        },
        'json'
      );

    });
  };

  script.rimToPreferiti = function() {

    var currentLocation = window.location;
    var uri = currentLocation.origin;
    $('a[data-rim]').click(function() {
      event.preventDefault();

      var auto = $(this).data('rim');
      console.log('Rimuovo ai preferiti '.auto);

      $.post(
        uri + "/wp-json/petrolini/v1/preferenze/rim", {
          idauto: auto
        },
        function(data) {
          $('.notificaRim-' + auto).animate({
            opacity: 1
          }, 2000);
          $('.notificaRim-' + auto).animate({
            opacity: 0
          }, 2000);
          location.reload();
        },
        'json'
      );
    });

  };

  script.caroselloMarche = function() {

    $('.caroselloMarche').slick({
      slidesToShow: 9,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            arrows: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          }
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  };

  script.caroselloOfferte = function() {

    $('.caroselloOfferte').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
          }
        },
        {
          breakpoint: 425,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,

          }
        }

        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  };

  script.immaginiDettAuto = function() {

    $('.immaginiDettAuto').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.mainImg',
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true,
      arrows: false
    });

  };

  script.mainImg = function() {

    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      arrows: false,
    });
  };

  script.caroselloTeam = function() {

    $('.caroselloTeam').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            arrows: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          }
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  };

  script.validatePermuta = function(){
		$('#submit').attr('disabled', true);
		$(document).on('change', '#autorizzazione1, #autorizzazione2', function(event) {
			event.preventDefault();
			/* Act on the event */
			if ($('#autorizzazione1').prop('checked') && $('#autorizzazione2').prop('checked')) {
				$('#submit').attr('disabled', false);
        $('.controllaCheck').hide();
			} else {
				$('#submit').attr('disabled', true);
			}
      if ($('#autorizzazione').prop('checked') == false || $('#offerte').prop('checked') == false) {
        $('.controllaCheck').show();

      }
		});
	};

	script.validateContatti = function(){
		$('#submit').attr('disabled', true);
		$(document).on('change', '#autorizzazione, #offerte', function(event) {
			event.preventDefault();
			/* Act on the event */
			if ($('#autorizzazione').prop('checked') && $('#offerte').prop('checked')) {
				$('#submit').attr('disabled', false);
        $('.controllaCheck').hide();
			} else {
				$('#submit').attr('disabled', true);
			}
      if ($('#autorizzazione').prop('checked') == false || $('#offerte').prop('checked') == false) {
        $('.controllaCheck').show();

      }
		});
	};

  script.showHideForm = function() {
    $('.hidecf').hide();
    $('#cf').removeAttr('required');
    $(document).trigger('needToRestartValdator');
		$('#formSubmit').attr('disabled', true);
		$(document).on('change', '#privacy1, #privacy2', function(event) {
			event.preventDefault();
			/* Act on the event */
			if ($('#privacy1').prop('checked') && $('#privacy2').prop('checked')) {
				$('#formSubmit').attr('disabled', false);
        $('.controllaCheck').hide();
			} else {
				$('#formSubmit').attr('disabled', true);
			}
      if ($('#privacy1').prop('checked') == false || $('#privacy2').prop('checked') == false) {
        $('.controllaCheck').show();

      }
		});

    //$('div.formshowHide *').removeAttr('required');
    //$('.formshowHide').hide();
    //$('.aggiungiVeicolo').click(function() {
    // $(document).trigger('needToRestartValdator');
    //$('.formshowHide').show();
    //$('.aggiungiVeicolo').hide();
    // $('div.formshowHide select').attr('required', 'required');
    // $('div.formshowHide input').attr('required', 'required');
    // $('div.formshowHide textarea').attr('required', 'required');
    // $('.formIniziamo').hide();
    //});
    // $('.rimuoviVeicolo').click(function() {
    //   $('.formshowHide').hide();
    //   $('.aggiungiVeicolo').show();
    //
    // });
    $('.tipocliente').change(function() {
      if ($('.tipocliente').val() == 'DITTE-INDIVIDUALI') {
        $('.hidecf').show();
        $('.hidePiva').show();
        $('#piva').removeAttr('required');
        $('#durataPiva').removeAttr('required');

        $(document).trigger('needToRestartValdator');

      } else if ($('.tipocliente').val() == 'PERSONE-FISICHE-PRIVATI') {
        $('.hidecf').show();
        $('.hidePiva').hide();
        $('.hideNomeAzienda').hide();
        $('#NomeAzienda').removeAttr('required');
        $('#piva').removeAttr('required');
        $('#durataPiva').removeAttr('required');
        $(document).trigger('needToRestartValdator');


      } else if ($('.tipocliente').val() == 'PENSIONATI') {
        $('.hidecf').show();
        $('.hidePiva').hide();
        $('.hideNomeAzienda').hide();
        $('.hidePosizioneAziendale').hide();
        $('#piva').removeAttr('required');
        $('#posizioneAziendale').removeAttr('required');
        $('#durataPiva').removeAttr('required');
        $('#NomeAzienda').removeAttr('required');
        $(document).trigger('needToRestartValdator');

      } else if ($('.tipocliente').val() == 'SOCIETA-DI-CAPITALI') {
        $('.hidecf').hide();
        $('#cf').removeAttr('required');
        $(document).trigger('needToRestartValdator');

      } else if ($('.tipocliente').val() == 'SOCIETA-DI-PERSONE') {
        $('.hidecf').hide();
        $('#cf').removeAttr('required');
        $(document).trigger('needToRestartValdator');

      } else if ($('.tipocliente').val() == 'ENTI-PUBBLICI') {
        $('.hidecf').hide();
        $('.hidePiva').show();
        $('#cf').removeAttr('required');
        $(document).trigger('needToRestartValdator');

      } else if ($('.tipocliente').val() == 'ASSOCIAZIONE-ENTE-FONDAZIONE') {
        $('.hidecf').hide();
        $('#cf').removeAttr('required');
        $(document).trigger('needToRestartValdator');

      } else if ($('.tipocliente').val() == 'STUDI-ASSOCIATI-ASSOCIAZIONI-ARTISTI-LIB-PROF') {
        $('.hidecf').hide();
        $('#cf').removeAttr('required');
        $(document).trigger('needToRestartValdator');

      } else {
        $('.hidecf').show();
        $('.hidePiva').show();
        $('.hideNomeAzienda').show();
        $('.hidePosizioneAziendale').show();
        $('#NomeAzienda').attr('required', 'required');
        $('#piva').attr('required', 'required');
        $('#durataPiva').attr('required', 'required');
        $('#posizioneAziendale').attr('required', 'required');
        $('#cf').attr('required', 'required');


        $(document).trigger('needToRestartValdator');
      }
    });

  };

  script.deleteItem = function() {
    $('.btnRipristina').hide();
    $('.btnDelete').click(function() {
      var idVeicolo = $(this).attr('data-auto');
      $('#auto-' + idVeicolo + ' .utilityBorder').hide();
      $('#auto-' + idVeicolo + ' input.active').val(0);
      $('#auto-' + idVeicolo + ' .btnRipristina').show();

    });
    $('.btnRipristina').click(function() {
      var idVeicolo = $(this).attr('data-auto');
      $('#auto-' + idVeicolo + ' .utilityBorder').show();
      $('#auto-' + idVeicolo + ' input.active').val(1);
      $('#auto-' + idVeicolo + ' .btnRipristina').hide();
    });
  };

  script.feedImg = function() {

    $('input[type=file]').bind('change', function() {
      $('input[type=file]').each(function(el) {
        //console.log(el);
        var str = $(this).val().replace("C:\\fakepath\\", "");
        //console.log(str);
        if (str != 0) {
          $(this).text('Immagine ' + ' ' + str + ' ' + ' inserita correttamente').css('color', '#12bc53').show();
        }
      });
    }).change();
  };
  script.contopref = function() {
    var currentLocation = window.location;
    var uri = currentLocation.origin;
    $.get(uri + '/wp-json/petrolini/v1/preferenze/list', function(data) {
      var contopref = data.length;
      if (contopref)
        $('.stellaPreferenze a').append('<span class="ml-1 badge badge-light">' + contopref + '</span>');
    });
  };
  script.excerpt = function() {
    $('.descauto-content').hide();
    $('.descauto-showmore').click(function(event) {
      $('.descauto-content').show();
      $('.descauto-excerpt').hide();
    });
  };
  // $(document).keypress(
  //   function(event) {
  //     if (event.which == '13') {
  //       event.preventDefault();
  //     }
  //   });

  script.moduloricerca = function() {
    //$('.wrapFormRicerca').hide();
    $('.wrapRicerca').click(function(event) {
      $(".wrapFormRicerca").toggle("fast", function() {
        // Animation complete.
      });
    });
  };

  script.sideBarMove = function () {

      $(window).scroll(function() {

        var winWidth = $( window ).width();

        if ( winWidth > 992) {
          console.log('maggiore');
          var height = $(window).scrollTop();
          if(height  > 157) {
            $('.sidebarMove').addClass('actveSidebar');
          } else {
            $('.sidebarMove').removeClass('actveSidebar');
          }
        }

      });
  }
  /* Start Functions */
  $(document).ready(function() {

    $("#submit").bind('click', function(event) {
      $('.invioMail').css('color', '#12bc53').show();
    });

    script.addToPreferiti();
    script.caroselloMarche();
    script.caroselloOfferte();
    script.immaginiDettAuto();
    script.mainImg();
    script.caroselloTeam();
    script.showHideForm();
    script.deleteItem();
    script.rimToPreferiti();
    script.feedImg();
    script.excerpt();
    script.contopref();
    script.moduloricerca();
		script.validateContatti();
    script.validatePermuta();
    script.sideBarMove();

  });
})(jQuery);
